import React, { Component } from "react";
import Flag from "react-flagkit";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Col, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import { getPortName } from "../../../../utils/service";
import { SearchLink } from "./SearchLink";

const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

class SearchResultByIP extends Component {
  render() {
    const { data } = this.props;
    const {
      city,
      state,
      country_name,
      postal_code,
      region_code,
      area_code,
      dma_code,
      latitude,
      longitude,
      domains,
      host_names,
      timezone,
      as_number,
      as_name,
      as_bgp_prefix,
      as_country_code,
      as_registry,
      as_allocated_date,
      as_organization,
      peer_asns,
      isp,
      organization,
      connection_type,
      os,
      discover_date,
      open_ports,
      country_code,
      risk_level,
      threat,
    } = data;

    return (
      <div>
        <div className="d-flex justify-content-start align-items-center flex-wrap">
          <h5 className="mr-3">
            IP Address : <SearchLink searchTerm={data.ip_addr} />
          </h5>
          {country_code ? <Flag country={country_code} className="mr-3" /> : ""}
          {risk_level ? <h5 className="mr-3">Risk Level : {risk_level}</h5> : ""}
          <h5 className={threat ? "mr-3" : ""}>
            {threat ? "Threat : " + threat : ""}
          </h5>
        </div>
        <div className="d-flex justify-content-start align-items-center flex-wrap">
          <h5 className="mr-3">
            Location:{" "}
            {[city, state, country_name, postal_code]
              .filter((x) => x)
              .join(", ")}
          </h5>
          <h5 className={region_code ? "mr-3" : ""}>
            {region_code ? "Region Code : " + region_code : ""}
          </h5>
          <h5 className={area_code ? "mr-3" : ""}>
            {area_code ? "Area Code : " + area_code : ""}
          </h5>
          <h5 className={dma_code ? "mr-3" : ""}>
            {dma_code ? "DMA Code : " + dma_code : ""}
          </h5>
          <h5 className="mr-3">{"Latitude : " + latitude}</h5>
          <h5 className="mr-3">{"Longitude : " + longitude}</h5>
          <h5 className={timezone ? "mr-3" : ""}>
            {timezone ? "Timezone : " + timezone : ""}
          </h5>
        </div>
        {0 === domains.length ? (
          <div></div>
        ) : (
          <div>
            <h5>Domains :</h5>
            <div className="pl-3">
              <Row>
                {domains.map((item, index) => (
                  <Col key={index} sm={12} lg={6} xl={4}>
                    <p>{item}</p>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        )}
        {0 === host_names.length ? (
          <div></div>
        ) : (
          <div>
            <h5>Host Names :</h5>
            <div className="pl-3">
              {host_names.map((item, index) => (
                <div key={index}>
                  <p>
                    <SearchLink searchTerm={item} />
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
        <h5>AS Information :</h5>
        <ReactTable
          showPagination={false}
          pageSize={1}
          data={[
            {
              as_number: <SearchLink searchTerm={as_number} />,
              as_name,
              as_bgp_prefix,
              as_country_code,
              as_registry,
              as_allocated_date,
              as_organization,
            },
          ]}
          columns={[
            { Header: "ASN", accessor: "as_number" },
            { Header: "BGP Prefix", accessor: "as_bgp_prefix" },
            { Header: "CC", accessor: "as_country_code" },
            { Header: "Registry", accessor: "as_registry" },
            { Header: "Allocated", accessor: "as_allocated_date" },
            { Header: "AS Name", accessor: "as_name" },
            { Header: "Organization", accessor: "as_organization" },
          ]}
        />
        {0 === peer_asns.length ? (
          <div></div>
        ) : (
          <div>
            <h5>Peer ASNs :</h5>
            <ReactTable
              showPagination={false}
              pageSize={peer_asns.length}
              data={peer_asns.map((p) => ({
                ...p,
                as_number: <SearchLink searchTerm={p.as_number} />,
              }))}
              columns={[
                { Header: "ASN", accessor: "as_number" },
                { Header: "BGP Prefix", accessor: "as_bgp_prefix" },
                { Header: "CC", accessor: "as_country_code" },
                { Header: "Registry", accessor: "as_registry" },
                { Header: "Allocated", accessor: "as_allocated_date" },
                { Header: "AS Name", accessor: "as_name" },
              ]}
            />
          </div>
        )}
        {0 === open_ports.length ? (
          <div></div>
        ) : (
          <div>
            <h5>Opened Ports :</h5>
            <div className="pl-3">
              {open_ports.map((item, index) => (
                <div key={index}>
                  <p>
                    {item} : {getPortName(item)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
        <h5>Other Information : </h5>
        <div className="pl-3">
          <p>{isp ? "Internet Service Provider : " + isp : ""}</p>
          <p>{organization ? "Organization : " + organization : ""}</p>
          <p>{os ? "Operating System : " + os : ""}</p>
          <p>{connection_type ? "Connection Type : " + connection_type : ""}</p>
          <p>{discover_date ? "Discover Date : " + discover_date : ""}</p>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultByIP);
